import { useState } from "react";
import { ChevronDown, ChevronRight, RotateCcw, Trash2, FileDown, XCircle } from "lucide-react";
import { http, toastApiError, downloadUrl } from "../../lib/api";
import { fmtTL, fmtDate, fmtCreator } from "../../lib/format";
import { toast } from "../../lib/notify";

// Silinen proje maliyetleri — elle silinenler ve hakediş silinince birlikte silinenler (deleted_reason); yönetici geri alabilir / kalıcı silebilir; satır ve liste Excel
export function DeletedCostsList({ items, userLabels, isAdmin, onRestored }) {
  const [open, setOpen] = useState(false);
  if (!items.length) return null;
  const restore = async (k) => {
    try { await http.post(`/project-costs/${k.id}/restore`); toast.success("Maliyet geri alındı"); onRestored?.(); }
    catch (e) { toastApiError(e); }
  };
  const purge = async (k) => {
    if (!window.confirm(`${k.project_name || ""} ${k.period} ${k.category_name || ""} maliyeti kalıcı olarak silinsin mi? Bu işlem geri alınamaz.`)) return;
    try { await http.delete(`/project-costs/${k.id}/purge`); toast.success("Maliyet kalıcı olarak silindi"); onRestored?.(); }
    catch (e) { toastApiError(e); }
  };
  return (
    <div className="space-y-2" data-testid="pcost-deleted">
      <div className="flex items-center gap-3 flex-wrap">
        <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="pcost-deleted-toggle"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-700 hover:text-slate-900">
          {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          <Trash2 className="w-3.5 h-3.5 text-red-600" /> Silinen Proje Maliyetleri
          <span className="px-1.5 py-0.5 rounded bg-red-100 text-red-700 text-[10px] font-bold" data-testid="pcost-deleted-count">{items.length}</span>
        </button>
        {open && <a href={downloadUrl("/project-costs/deleted/export")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-800 hover:underline" data-testid="pcost-deleted-export-all" title="Silinen maliyetlerin tamamı (kalemleriyle) Excel"><FileDown className="w-3.5 h-3.5" /> Listeyi Excel'e aktar</a>}
      </div>
      {open && (
        <div className="bg-white border border-red-200 rounded-lg overflow-hidden">
          <table className="w-full tbl">
            <thead className="bg-red-50/60">
              <tr>
                {["Proje", "Dönem", "Ana Başlık", "Hakediş No", "Toplam Maliyet", "Silen", "Silinme", "Neden", ""].map((h, i) => (
                  <th key={h || i} className={`px-3 py-2 text-xs uppercase tracking-wider text-slate-600 font-semibold ${i === 4 ? "text-right" : "text-left"}`}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((k) => (
                <tr key={k.id} className="border-t border-slate-100 text-slate-500" data-testid={`pcost-deleted-row-${k.id}`}>
                  <td className="px-3 py-2 text-xs">{k.project_name || "—"}</td>
                  <td className="px-3 py-2 text-xs">{k.period}</td>
                  <td className="px-3 py-2 text-xs">{k.category_name || "—"}</td>
                  <td className="px-3 py-2 text-xs font-mono">{k.invoice_no || "—"}</td>
                  <td className="numeric-cell px-3 py-2 text-xs font-semibold line-through">{fmtTL(k.total)}</td>
                  <td className="px-3 py-2 text-[11px] whitespace-nowrap">{k.deleted_by ? fmtCreator(k.deleted_by, k.deleted_at, userLabels) : "—"}</td>
                  <td className="px-3 py-2 text-xs">{fmtDate((k.deleted_at || "").slice(0, 10))}</td>
                  <td className="px-3 py-2 text-xs" data-testid={`pcost-deleted-reason-${k.id}`}>{k.deleted_reason || "Elle silindi"}</td>
                  <td className="px-3 py-2 text-right whitespace-nowrap space-x-3">
                    <a href={downloadUrl(`/project-costs/${k.id}/export`)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-emerald-800 hover:text-emerald-900 text-xs font-semibold" title="Bu maliyeti kalemleriyle Excel indir" data-testid={`pcost-deleted-export-${k.id}`}><FileDown className="w-3.5 h-3.5" /> Excel</a>
                    {isAdmin && <button onClick={() => restore(k)} className="inline-flex items-center gap-1 text-emerald-700 hover:text-emerald-900 text-xs font-semibold" title="Geri al" data-testid={`pcost-deleted-restore-${k.id}`}><RotateCcw className="w-3.5 h-3.5" /> Geri Al</button>}
                    {isAdmin && <button onClick={() => purge(k)} className="inline-flex items-center gap-1 text-red-700 hover:text-red-900 text-xs font-semibold" title="Kalıcı sil (geri alınamaz)" data-testid={`pcost-deleted-purge-${k.id}`}><XCircle className="w-3.5 h-3.5" /> Sil</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
